import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import CarruselImagenesDetalles from '../Carrusel_Imagenes/CarruselImagenes';
import { logistica_GUIA_FOTO } from '@pcgerente-node/pcg-comun/dist/DTOs';

interface ChildsProps {
    fotos: logistica_GUIA_FOTO[]
}

const ModalImagenes: React.FC<ChildsProps> =({fotos}) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    return (
      <>
        {fotos.map(foto =>
            <img 
              key={foto.id}
              src={foto.url} 
              width="175px"
              height="175px"
              className='ml-1 mr-1'
              alt={`foto N#${foto.id}`}
              onClick={() =>handleShow()} 
            />
        )}
  
        <Modal
            show={show} onHide={handleClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            variant={"dark"}
        >

          <Modal.Body>
            <CarruselImagenesDetalles fotos={fotos}/>
        </Modal.Body>
          
        </Modal>
      </>
  );
}

export default ModalImagenes
